import { useAppSettingStore } from '@/client/store/app-store';
import { api } from '@/client/utils/api';
import { useMarkets } from '@/libs/react-sdk/api/use-markets';
import { MarketsSortType, type MarketsParams } from '@/libs/sdk/api';

// Volume-ranked markets for the current base-token lens. Exported so every
// consumer builds the searchParams object the exact same way -- that is what
// makes their react-query keys match and collapse into one request.
// 48 rather than 24: consumers drop event legs whose siblings fall outside the
// page (see dropTruncatedEventLegs / selectTickerMarkets), so a window too small
// to hold whole events thins the rail and the ticker.
export const buildTrendingMarketsParams = (baseTokenAddress: string): MarketsParams => ({
  page: 1,
  pageSize: 48,
  sortType: MarketsSortType.volume,
  sortAsc: false,
  baseTokenAddress,
});

// Home "Trending now" rail (ported from AIP's shared trending/search-recommend
// hook; DPIN only wires the rail for now).
export const useTrendingMarkets = (options?: { enabled?: boolean }) => {
  const lensTokenAddress = useAppSettingStore(state => state.baseToken.address);
  return useMarkets(api, buildTrendingMarketsParams(lensTokenAddress), {
    enabled: options?.enabled,
    // Without this, react-query's default staleTime of 0 marks the rail's
    // data stale immediately and refetches on every mount.
    staleTime: 30_000,
  });
};
